import { Globe, Settings, Upload } from 'lucide-react';

export const SidebarActionsSection = ({ onUpload, onCrawl, onManageDocuments }) => (
  <div className="space-y-3">
    <h3 className="text-xs font-mono uppercase tracking-widest text-muted-foreground/60">
      Actions
    </h3>

    <button
      data-testid="upload-pdf-button"
      onClick={onUpload}
      className="flex w-full items-center gap-3 rounded-sm border border-zinc-800 bg-transparent p-3 text-white transition-all duration-300 hover:border-white hover:bg-zinc-900/50"
    >
      <Upload className="h-4 w-4" />
      <span className="text-sm">Uploader un PDF</span>
    </button>

    <button
      data-testid="crawl-url-button"
      onClick={onCrawl}
      className="flex w-full items-center gap-3 rounded-sm border border-zinc-800 bg-transparent p-3 text-white transition-all duration-300 hover:border-white hover:bg-zinc-900/50"
    >
      <Globe className="h-4 w-4" />
      <span className="text-sm">Crawler un site</span>
    </button>

    <button
      data-testid="manage-documents-button"
      onClick={onManageDocuments}
      className="flex w-full items-center gap-3 rounded-sm border border-zinc-800 bg-transparent p-3 text-white transition-all duration-300 hover:border-white hover:bg-zinc-900/50"
    >
      <Settings className="h-4 w-4" />
      <span className="text-sm">Gérer les documents</span>
    </button>
  </div>
);
